import { render } from "./NodeMetadata.vue?vue&type=template&id=4979e764&scoped=true&ts=true"
import script from "./NodeMetadata.vue?vue&type=script&lang=ts"
export * from "./NodeMetadata.vue?vue&type=script&lang=ts"

import "./NodeMetadata.vue?vue&type=style&index=0&id=4979e764&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4979e764"]])

export default __exports__